/** localStorage-backed draft persistence for the map artifact viewer.
 *  Keyed by artifact_id; survives page refresh and tab restoration. */
import type { GeoJSONFeatureCollection, MapView } from '../types/gis';

export interface ArtifactDraft {
  data: GeoJSONFeatureCollection;
  metadata: { map_view?: MapView } & Record<string, any>;
  saved_at: string;
}

export function draftKey(artifactId: string): string {
  return `gis:draft:${artifactId}`;
}

export function saveDraft(
  artifactId: string,
  payload: Omit<ArtifactDraft, 'saved_at'>,
): void {
  try {
    const full: ArtifactDraft = { ...payload, saved_at: new Date().toISOString() };
    localStorage.setItem(draftKey(artifactId), JSON.stringify(full));
  } catch (e) {
    // Silent — quota errors / private mode shouldn't crash the editor
    console.warn('draftStorage.saveDraft failed', e);
  }
}

export function loadDraft(artifactId: string): ArtifactDraft | null {
  try {
    const raw = localStorage.getItem(draftKey(artifactId));
    if (!raw) return null;
    return JSON.parse(raw) as ArtifactDraft;
  } catch {
    return null;
  }
}

export function clearDraft(artifactId: string): void {
  try {
    localStorage.removeItem(draftKey(artifactId));
  } catch {
    /* noop */
  }
}
